import React, {useEffect, useState} from 'react'
import {Box, FormControl, IconButton, TextField} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import {AddFolderIcon} from '../../../../helpers/Icons'
import AddFolderDialog from './AddFolderDialog';


function FolderSelector(props) {
  const { selectedFolder, folderList, addFolder, handleFolderSelect, margin="dense", ...rest } = props;
  const [isAddFolderOpen, setAddFolderOpen] = useState(false);

  const selectFolder = (f) => {
    handleFolderSelect(f);
  }

  useEffect(() => {
      if(!folderList || folderList.length === 0){
        return;
      }
      const folder = !selectedFolder ? null : folderList.find(f => f.id === selectedFolder.id);
      if(!folder){
        selectFolder(folderList[0]);
      }else{
        if(folder.updated_at > selectedFolder.updated_at){
          selectFolder(folder);
        }
      }
    },
    // eslint-disable-next-line
    [folderList]
  );

  const openAddFolderDialog = () => {
    setAddFolderOpen(true);
  };

  const closeAddFolderDialog = (folderName) => {
    setAddFolderOpen(false);
  }

  return <>
      <FormControl {...rest} size="small" margin={margin} fullWidth>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            {!folderList || folderList.length === 0 ? <> *No folders available* </> :
              <Autocomplete
                autoComplete
                autoSelect
                autoHighlight
                disableClearable
                value={selectedFolder}
                options={folderList}
                getOptionSelected={(f) => f.id === selectedFolder.id}
                getOptionLabel={(f) => f.name ? f.name : ''}
                onChange={(event, value, reason) => {selectFolder(value)}}
                renderInput={params => <TextField className="folder-select" {...params} variant="outlined" label="Folder" />}
                size="small"
                margin='dense'
              />
            }
          </Box>
          <IconButton className="folder-select-add-btn" onClick={openAddFolderDialog} size="small" style={{marginLeft:'calc(0.5em - 3px)', color:'inherit'}}>
            <AddFolderIcon />
          </IconButton>
        </Box>
        <AddFolderDialog
          className="folder-select-add-dialog"
          isOpen={isAddFolderOpen}
          closeDialog={closeAddFolderDialog}
          addFolder={(name, desc) => addFolder(name, desc, (f) => selectFolder(f))} />
      </FormControl>
  </>
}

export default FolderSelector;
